module.exports = __webpack_public_path__ + "img/location.1b7b61ad.svg";